









































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DecisionManageUsers from "@/components/decisions/DecisionManageUsers.vue";
import ListInput from "@/components/forms/ListInput.vue";
import { getModule } from "vuex-module-decorators";
import Decisions from "@/store/modules/Decisions";
import Users from "@/store/modules/Users";
import { USERS } from "@/api/UserManagementDao";
import _ from "lodash";
import { EMAIL_FORMAT } from "@/rules";
import { VIEWPOINT_API } from "@/api/ViewpointApi";

const decisionsModule = getModule(Decisions);
const usersModule = getModule(Users);
const usersDao = USERS

@Component({
    components: {
        DecisionManageUsers,
        ListInput,
    },
})

export default class DecisionShareDialog extends Vue {

    @Prop({default: '', type: String})
    header!: string;

    @Prop({default: 'primary', type: String})
    color!: string;

    @Prop({default: '', type: String})
    placeholder!: string;

    @Prop({default: '', type: String})
    hint!: string;

    @Prop({default: '', type: String})
    label!: string;

    @Prop({default: 'mdi-share', type: String})
    icon: string;

    @Prop({default: false, type: Boolean})
    xSmall: boolean;

    @Prop({default: false, type: Boolean})
    small: boolean;

    @Prop({default: false, type: Boolean})
    large: boolean;

    @Prop({default: false, type: Boolean})
    xLarge: boolean;

    @Prop({default: false, type: Boolean})
    nav: boolean;

    @Prop({default: false, type: Boolean})
    disabled!: boolean;

    private dialog: boolean = false;
    private showAdd: boolean = true;
    private loading: boolean = false;
    private valid: boolean = false;
    private email: string = '';
    private searchPossibleUsers: any = {};
    private userInDb:boolean = false;
    private searchUserByEmailDebonce:any ={}
    private message: string = '';
    private info: string = 'Add a User by Email';
    private invalid: string = 'Please enter a VALID Email Address';
    private errored: string = 'There was an Error processing this email';
    private submitting: string = 'Submitting ...';
    private possibleUsers: any[] = [];
    private emailSearch = ''
    private searchUsersLoading = false;
    private permission = this.userRole === 'ADMIN' || this.isOwner ? "ADMIN": 'EDIT';
    private roles = 
        [
            {
                value: 'ADMIN',
                text: 'ADMIN'
            },
            {
                value: 'EDIT',
                text: 'EDITOR',
            },
            {
                value: 'USER',
                text: 'USER',
            }
        ]
    created() {
        // this.searchPossibleUsers = _.debounce(this.getPublicProfiles, 1000);
        this.searchUserByEmailDebonce = _.debounce(this.searchUserByEmail, 1000);
        this.message = this.info;
        if (this.numberOfUsers) {
            this.showAdd = false;
        }
    }

    get decisionUsers() {
        return decisionsModule.selectedDecisionUsers;
    }

    get decisionAdminUsers(): string[] {
        if (!decisionsModule.selectedDecision) return ['[admins]'];
        return [decisionsModule.selectedDecision.ownerUserId];
    }

    get validEmail() {
        return this.emailSearch && EMAIL_FORMAT(this.emailSearch) === true;
    }

    get userId(): string {
        if (usersModule.currentUserProfile) {
            return usersModule.currentUserProfile.userId;
        }
        return '[user]';
    }

    get userRole() {
        return decisionsModule.selectedDecisionUsers[this.userId]?.permissionAccess;
    }

    get isOwner(): boolean {
        return (this.decisionAdminUsers.includes(this.userId));
    }

    get tabTitle(): string {
        if (this.isOwner) {
            return 'VIEW / EDIT';
        }
        return 'VIEW';
    }

    get numberOfUsers(): number {
        return Object.values(this.decisionUsers).length;
    }

    get isEmailInUsers() {
        return this.possibleUsers.filter((val) => val.email === this.email.toLowerCase() && val.type).length > 0
    }

    @Watch('email')
    search(emailPrefix: string) {
        this.emailSearch = this.email.toLowerCase();
        if(this.validEmail) {
            this.searchUsersLoading = true;
            this.searchUserByEmail();
        }
    }

    private async searchUserByEmail(){
        try{
            if(this.emailSearch){
                console.log('a');
                let foundUsers = await usersModule.searchUsersByEmailPrefix(this.emailSearch) as any;
                console.log(foundUsers);
                if(foundUsers && foundUsers.length===1){
                    if(this.email.toLowerCase() === foundUsers[0].email){
                        
                        this.userInDb = true;
                    }else{
                        this.userInDb = false;
                    }
                }else{
                    this.userInDb = false;
                }
            }
            this.searchUsersLoading = false;
        }catch(error){
            console.log(error);
            this.searchUsersLoading = false;
        }  

    }

    private getPublicProfiles() {
        if (this.emailSearch) {
            usersDao.searchPublicUserProfilesByEmailPrefix(this.emailSearch)
                .then((possibleUsers: any[]) => {
                    let users;
                    this.message = ''
                    if (possibleUsers.length === 0) {
                        if (!this.validEmail) {
                            this.message = this.invalid
                            users = [];
                        } else {
                            users = [{userId: this.emailSearch, email: this.emailSearch}]
                        }
                    } else {
                        users = possibleUsers
                    }
                    this.possibleUsers = users
                        .filter(u => !decisionsModule.selectedDecisionUsers.hasOwnProperty(u.userId))
                        .filter(u => !this.decisionAdminUsers.includes(u.userId))
                    this.searchUsersLoading = false;
                });
        } else {
            this.possibleUsers = [];
            this.searchUsersLoading = false;
        }
    }

    private async submit() {
        this.message = this.submitting;
        this.loading = true;
        try {
            console.log(`user permission${this.permission}`);
            let foundUsers = await usersModule.searchUsersByEmailPrefix(this.email.toLowerCase())
            if (foundUsers && foundUsers.length === 1&& foundUsers[0].email === this.email.toLowerCase()) {
                //await decisionsModule.inviteUserToDecisionByUserId(foundUsers[0].userId);
                await decisionsModule.joinUserToDecision({'userId': foundUsers[0].userId, 'permission': this.permission})
                this.loading = false;
                this.valid = false;
                this.message = this.info;
                this.email = '';
                return;
            }
            await decisionsModule.inviteUserToDecisionByEmail({'email': this.emailSearch, 'permissions': this.permission})
            this.loading = false;
            this.valid = false;
            this.message = this.info;
            this.email = '';
        } catch (err) {
            this.loading = false;
            this.message = this.errored;
        }
    }

    private cancel() {
        this.dialog = false;
    }

    

}

